import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './TotalDonationAmount.module.css';
import DonationAmountSum from '@/donationPages/_dependencies/components/DonationAmountSum';
function TotalDonationAmount() {
  const $ = _c(12);
  const t = useTranslations("nextjs.donate.total_donation_amount");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DonationAmountSum fields={["amount_cents", "codonation_cents"]} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("total");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className={styles.sumLabelContainer}>{t0}<span className={styles.sumLabel}>{t1}</span></span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("impact");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className={styles.impactText}>{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <LayoutStack className={styles.amountSumContainer}>{t2}{t4}</LayoutStack>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export default TotalDonationAmount;